import React from 'react'
import { BlogsList } from './BlogList'

export const HomeRepair = (props) => {
    const latestBlogs = props.latestBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <div className='space-y-8 px-2'>
        <div className='space-y-5 pt-5'>
            <h1 className='font-bold text-2xl md:text-3xl text-center'>
                Home Repair & Renovation
            </h1>
            {/* The static StringsSG guides (utils/sg-blogs-data.js) go first. Passed
                through the same BlogsList, they would render after up to 100
                WordPress posts, where nobody would find them. */}
            {latestBlogs?.length > 0 &&
                <section aria-labelledby='repair-guides-heading'>
                    <h2 id='repair-guides-heading' className='font-bold text-xl md:text-2xl text-center pt-2'>
                        Plumbing Problem Guides
                    </h2>
                    <BlogsList blogs={latestBlogs} listAll={true}/>
                </section>
            }
            <BlogsList blogs={[]} listAll={true} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
    </div>
  )
}
